import { useUserStore } from "@/store/user";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";

export default async ({ from, to, redirect, pinia }: MiddlewareInterface) => {
  const profile = useUserStore(pinia).getProfile;

  if (to.meta.cameraFraudRestricted && profile?.camera_fraud) {
    if (from.path === "/") {
      redirect("/");
      return;
    }

    redirect(false);
  }
};
